import { Injectable } from '@angular/core';
import { BehaviorTrackerScriptInjectorService } from 'app/behavior-tracking/behavior-tracker-script-injector.service';
import { IBehaviorTrackingProvider } from 'app/behavior-tracking/interfaces/behavior-tracking-provider.interface';
import { environment } from 'environments/environment';

@Injectable()
export class GtmTrackingProviderService implements IBehaviorTrackingProvider {
    public name = 'gtm';

    public constructor(private scriptInjector: BehaviorTrackerScriptInjectorService) {
        if (!environment.feature.behaviorTrackingAnalytics?.enabled) {
            return;
        }

        const gtmConfig = environment.feature?.behaviorTrackingAnalytics?.gtm;
        if (!gtmConfig?.enabled) {
            return;
        }

        const gtmId = environment.feature?.behaviorTrackingAnalytics?.gtm.id;
        this.scriptInjector.injectScript(`${gtmConfig.script.url}?id=${ gtmId }`, 'gtm-script');
        this.scriptInjector.injectNoScriptIframe(`${gtmConfig.noscript.url}?id=${ gtmId }`);
    }

    public capture(event: string, data: Record<string, unknown> = {}): void {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({ event, ...data });
    }

    public identify(userId: string, properties?: Record<string, any>): void {
        this.capture('identify', { userId, ...properties });
    }
}
